import React from 'react';
import GraphViewControlBar from '../GraphViewControlBar.tsx';
import { ChartType } from '../../../../pages/Summary/Components/Charts/ChartTypes.ts';

const AssetByClientAttributesType: React.FC = () => {
	return <GraphViewControlBar chartType={ChartType.ASSET_CLIENT_ATTRIBUTES} viewAll/>;
};

export default AssetByClientAttributesType;
